import type { ColorPreset } from './appearanceColorPresetTypes'

export const DARK_COLOR_PRESETS: ColorPreset[] = [
  {
    id: 'agrada-green',
    name: 'Agrada Green',
    description: 'Padrão do sistema',
    swatch: ['#40C351', '#0f1e14', '#1a2f1e', '#ffffff', '#9ca3af'],
    colors: {
      mode: 'dark' as const,
      brandPrimary: '#40C351',
      brandPrimaryHover: '#35a844',
      brandPrimaryMuted: '#1a3d22',
      brandSecondary: '#72C063',
      brandSecondaryHover: '#5da84f',
      fontColorH1: '#ffffff',
      fontColorH2: '#e5e7eb',
      fontColorH3: '#d1d5db',
      fontColorBody: '#d1d5db',
      fontColorMuted: '#9ca3af',
      fontColorLabel: '#6b7280',
    },
  },
  {
    id: 'ocean-blue',
    name: 'Ocean Blue',
    description: 'Confiança e profissionalismo',
    swatch: ['#3b82f6', '#1e3a5f', '#1e293b', '#f0f7ff', '#94a3b8'],
    colors: {
      mode: 'dark' as const,
      brandPrimary: '#3b82f6',
      brandPrimaryHover: '#2563eb',
      brandPrimaryMuted: '#1e3a5f',
      brandSecondary: '#38bdf8',
      brandSecondaryHover: '#0ea5e9',
      fontColorH1: '#f0f9ff',
      fontColorH2: '#e0f2fe',
      fontColorH3: '#bae6fd',
      fontColorBody: '#cbd5e1',
      fontColorMuted: '#94a3b8',
      fontColorLabel: '#64748b',
    },
  },
  {
    id: 'royal-purple',
    name: 'Royal Purple',
    description: 'Sofisticação e criatividade',
    swatch: ['#8b5cf6', '#2e1065', '#1e1b4b', '#faf5ff', '#a78bfa'],
    colors: {
      mode: 'dark' as const,
      brandPrimary: '#8b5cf6',
      brandPrimaryHover: '#7c3aed',
      brandPrimaryMuted: '#2e1065',
      brandSecondary: '#a78bfa',
      brandSecondaryHover: '#8b5cf6',
      fontColorH1: '#faf5ff',
      fontColorH2: '#ede9fe',
      fontColorH3: '#ddd6fe',
      fontColorBody: '#c4b5fd',
      fontColorMuted: '#a78bfa',
      fontColorLabel: '#7c3aed',
    },
  },
  {
    id: 'solar-orange',
    name: 'Solar Orange',
    description: 'Energia e alta performance',
    swatch: ['#f97316', '#431407', '#1c0a00', '#fff7ed', '#fdba74'],
    colors: {
      mode: 'dark' as const,
      brandPrimary: '#f97316',
      brandPrimaryHover: '#ea580c',
      brandPrimaryMuted: '#431407',
      brandSecondary: '#fb923c',
      brandSecondaryHover: '#f97316',
      fontColorH1: '#fff7ed',
      fontColorH2: '#ffedd5',
      fontColorH3: '#fed7aa',
      fontColorBody: '#fdba74',
      fontColorMuted: '#fb923c',
      fontColorLabel: '#ea580c',
    },
  },
  {
    id: 'steel-gray',
    name: 'Steel Gray',
    description: 'Neutro e corporativo',
    swatch: ['#6b7280', '#1f2937', '#111827', '#f9fafb', '#9ca3af'],
    colors: {
      mode: 'dark' as const,
      brandPrimary: '#6b7280',
      brandPrimaryHover: '#4b5563',
      brandPrimaryMuted: '#1f2937',
      brandSecondary: '#9ca3af',
      brandSecondaryHover: '#6b7280',
      fontColorH1: '#f9fafb',
      fontColorH2: '#f3f4f6',
      fontColorH3: '#e5e7eb',
      fontColorBody: '#d1d5db',
      fontColorMuted: '#9ca3af',
      fontColorLabel: '#6b7280',
    },
  },
  {
    id: 'crimson-red',
    name: 'Crimson Red',
    description: 'Urgência e alta conversão',
    swatch: ['#ef4444', '#450a0a', '#1c0505', '#fef2f2', '#fca5a5'],
    colors: {
      mode: 'dark' as const,
      brandPrimary: '#ef4444',
      brandPrimaryHover: '#dc2626',
      brandPrimaryMuted: '#450a0a',
      brandSecondary: '#f87171',
      brandSecondaryHover: '#ef4444',
      fontColorH1: '#fef2f2',
      fontColorH2: '#fee2e2',
      fontColorH3: '#fecaca',
      fontColorBody: '#fca5a5',
      fontColorMuted: '#f87171',
      fontColorLabel: '#dc2626',
    },
  },
  {
    id: 'teal-pro',
    name: 'Teal Pro',
    description: 'Modernidade e inovação',
    swatch: ['#14b8a6', '#042f2e', '#0d1f1f', '#f0fdfa', '#5eead4'],
    colors: {
      mode: 'dark' as const,
      brandPrimary: '#14b8a6',
      brandPrimaryHover: '#0d9488',
      brandPrimaryMuted: '#042f2e',
      brandSecondary: '#2dd4bf',
      brandSecondaryHover: '#14b8a6',
      fontColorH1: '#f0fdfa',
      fontColorH2: '#ccfbf1',
      fontColorH3: '#99f6e4',
      fontColorBody: '#5eead4',
      fontColorMuted: '#2dd4bf',
      fontColorLabel: '#0d9488',
    },
  },
  {
    id: 'gold-premium',
    name: 'Gold Premium',
    description: 'Luxo e exclusividade',
    swatch: ['#f59e0b', '#451a03', '#1c0e00', '#fffbeb', '#fcd34d'],
    colors: {
      mode: 'dark' as const,
      brandPrimary: '#f59e0b',
      brandPrimaryHover: '#d97706',
      brandPrimaryMuted: '#451a03',
      brandSecondary: '#fbbf24',
      brandSecondaryHover: '#f59e0b',
      fontColorH1: '#fffbeb',
      fontColorH2: '#fef3c7',
      fontColorH3: '#fde68a',
      fontColorBody: '#fcd34d',
      fontColorMuted: '#fbbf24',
      fontColorLabel: '#d97706',
    },
  },
]
